import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('dock__point', {
  root: {
    variants: {
      position: [
        'top-left',
        'top',
        'top-right',
        'left',
        'center',
        'right',
        'bottom-left',
        'bottom',
        'bottom-right',
      ],
    },
    states: ['selected', 'disabled', 'offsetIcon'],
  },
  background: {},
  indicator: {},
  icon: {},
});
